import React, { useEffect, useCallback, useMemo } from 'react';
import { Redirect, Link, useLocation } from 'react-router-dom';
import Loading from '../components/Objects/Loading';
import { Confetti } from './Confetti';
import { PlantATree } from './PlantATree';
import { useGetStripeSession } from './queries';

import './PaymentSuccess.scss';

export function PaymentSuccess({ venue }) {
  const query = useLocationQuery();
  const sessionId = query.get('sessionId');

  const { isLoading, data, isSuccess } = useGetStripeSession(sessionId);

  if (isLoading) {
    return (
      <div className='inbox__section loading-container'>
        <Loading />
      </div>
    );
  }

  if (!isValidPayment(data)) {
    return <Redirect to='/inbox' />;
  }

  return (
    <>
      <div className='inbox__section payment-success'>
        <div className='payment-success__copy'>
          <Confetti />
          <h1>Your booking is confirmed</h1>
          <p>
            Your payment has been successfully sent to{' '}
            {venue.name ? `${venue.name} ` : 'the venue '}
            and your event is now confirmed.
          </p>
          <PlantATree />
          <p>
            <a href='/blog'>Need inspiration for planning your event?</a>
          </p>
        </div>
        <Link to='/inbox'>
          <button className='button button--dark'>Go to Inbox</button>
        </Link>
      </div>
    </>
  );
}

function isValidPayment(session) {
  return session.id && session.status === 'complete';
}

function useLocationQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}
